import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadMySitesSuccessAction, mySitesActionTypes} from '../actions/my-sites';
import {Site} from '../models/site';

export interface MySitesState {
  array: Site[];
}

const initialState: MySitesState = {
  array: []
};

export function mySitesReducer(state: MySitesState = initialState, action: Action): MySitesState {
  switch (action.type) {
    case mySitesActionTypes.LOAD:
      return handleLoadAction();
    case mySitesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case mySitesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): MySitesState {
  return initialState;
}

function handleLoadSuccess(state: MySitesState, action: LoadMySitesSuccessAction): MySitesState {
  const newState = _.clone(state);
  newState.array = action.payload || [];
  return newState;
}

function handleLoadFailAction(state: MySitesState): MySitesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const mySitesSelectors = {
  array: (state: MySitesState) => _.get(state, 'array', [])
};
